<template>
  <div>

    <v-row justify="center">
      <v-dialog v-model="dialogIndividual" width="1000px">
        <v-card>
          <v-card-text style="text-align: justify;">
            <div>
              <v-btn icon @click="dialogIndividual = false" style="float: right;">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <br>
              <br>
              <div style="background: #002C77; border-radius: 9px; text-align: center; width: 94%; margin: auto;">
                <div style="padding: 2%;">
                  <label style="font-family: Poppins; font-style: normal; font-weight: 700; font-size: 22px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;">Estas son las coberturas y protecciones
                    del </label>
                  <label style="font-family: Poppins; font-style: normal; font-weight: 700; font-size: 22px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;"><label
                      style="font-family: Poppins; font-style: normal; font-weight: 700;
                      font-size: 22px; line-height: 18px; letter-spacing: 0.02em; color: white; flex: none; order: 1; flex-grow: 0; text-transform: uppercase;">
                    </label> <br> Seguro Oncológico Clínica IRAM.
                  </label>
                </div>

              </div>


              <br>
              <br>

              <div style="padding-left: 9%; ">
                <label class="encabezado"> ⬤ <b> Cobertura completa en tratamiento oncológico </b> </label>
              </div>


              <br>
              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto">La cobertura tiene como finalidad complementar el régimen previsional de salud del
                  asegurado, sea Fonasa (B, C, D) o Isapre, proporcionando acceso a tratamientos, hospitalización para
                  patologías oncológicas y seguimiento oncológico, con cobertura vitalicia mientras el asegurado
                  mantenga su pago y contrato vigente.</label>
              </div>
              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto">La cobertura es de carácter asistencial y contempla una indemnización de UF 50 en
                  caso de diagnóstico de cáncer. El derecho a la indemnización no procederá si el diagnóstico de cáncer
                  es consecuencia de otro anterior cubierto por la póliza. Todos los tratamientos y prestaciones deben
                  ser indicados sólo por Clínica IRAM, realizados en su propia Clínica o en centros derivados por la
                  misma.</label>
              </div>
              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 5px">
                <label class="texto">La cobertura oncológica se inicia una vez que el paciente presenta el resultado de
                  una biopsia (informe histopatológico), que confirma que tiene cáncer. La realización de esta biopsia
                  es de cargo del asegurado.</label>
              </div>
              <br>

              <div style="padding-left: 9%; ">
                <label class="encabezado"> ⬤ <b> Beneficios adicionales </b> </label>
              </div>

              <br>

              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto">La cobertura y beneficios adicionales es complementaria al sistema previsional de
                  cada persona (Fonasa o Isapre), es decir cubrirá los valores copago no cubiertos por éstas.</label>
              </div>

              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de mama: </b> <br>
                  • 1 mamografía anual sin costo desde los 35 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de próstata:</b><br>
                  • 1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="buttonAceptar" elevation="0" text @click="dialogIndividual = false">
              Aceptar
            </v-btn>
            <br>
            <br>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>

    <div v-if="loadingPlans == false">

      <div>

      </div>
      <br>

      <v-row style="display: flex; align-items: flex-start;">

        <v-form ref="form" v-model="valid">

          <div style="margin-right: 20px;">

            <h3 class="text-center labelTituloo">{{ capitalizeName(userData.name) }},
              tenemos este plan para ti</h3>
            <br>

            <v-row style="
              background: #f7f7f7;
              border: rgba(226, 226, 226, 1) 1px solid;
              border-radius: 50px;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              padding:6px;
              width: 90%;
            ">
              <div style="justify-content: center; display: flex; height: 70px;">
                <img :src="imageIndividual" alt="Image i" @click="selectPlan(1)" style="cursor: pointer;">
              </div>
              <div v-if="userData.old.id < 53" style="justify-content: center; display: flex; height: 70px;">
                <img :src="imageFamiliar" alt="Image f" @click="selectPlan(2), dialog = true" style="cursor: pointer;">
              </div>
            </v-row>

            <v-navigation-drawer v-model="dialog" right temporary fixed width="450" class="family-drawer" app stateless
              touchless disable-route-watcher disable-resize-watcher>


              <v-card flat tile class="drawer-card">

                <v-card-title>

                  <v-row style="margin-left: 10%; margin-top: 2%;">

                    <img :src="popUpImage" alt="Image pop">

                    <v-col style="margin-left: 10%; display: flex; flex-direction: column; flex-wrap: wrap;align-content: stretch;
                          justify-content: space-evenly;  align-items: baseline; ">
                      <p style="color: #2D387C; font-weight: 600; align-items: left;">Plan familiar</p>
                      <p style="color: #353535; font-size: 15px; align-items: left; margin-top: -6%;">Agrega hasta 5
                        integrantes <br> de tu
                        grupo familiar.</p>
                    </v-col>

                    <span style="margin-right: 3%; font-size: 18px; cursor: pointer;" @click="dialog = false">X</span>

                  </v-row>

                  <hr class="hrline"><br>

                </v-card-title>

                <v-card-text style="text-align: justify;">

                  <v-col>
                    <p> <span style="font-weight: 700; color: #353535;">Ya estás incluido en el plan.</span> <br> Aquí
                      puedes agregar a tus cargas familiares. </p>

                    <br>

                    <div>

                      <div v-for="(benef, index) in benefData" :key="index" class="benef-card">
                        <div class="benef-header">
                          <p class="benef-title">FAMILIAR {{ index + 1 }}</p>

                          <button class="benef-remove" @click.prevent="deletedBeneficiary(index)">
                            Eliminar
                            <span class="benef-x">×</span>
                          </button>
                        </div>



                        <div class="field-row-2">

                          <div>
                            <label class="field-label">Nombre</label>
                            <v-text-field v-model="benef.name" class="input-sm" dense outlined rounded hide-details
                              :rules="nameRules" placeholder="Nombre" />
                          </div>

                          <div>
                            <label class="field-label">Apellido</label>
                            <v-text-field v-model="benef.surname" class="input-sm" dense outlined rounded hide-details
                              :rules="surnameRules" placeholder="Apellido" />
                          </div>

                        </div>

                        <div class="field-row-2">
                          <div>
                            <label class="field-label">Parentesco</label>
                            <v-select v-model="benef.tipo" :items="personType" class="input-sm" dense outlined rounded
                              :rules="parentescoRules" hide-details placeholder="Seleccione"
                              @change="change(index, benef.tipo)" />
                          </div>

                          <div>
                            <label class="field-label">Edad</label>

                            <v-select v-if="benef.tipo != 'Hijo(a)'" v-model="benef.edad" :items="partnerList"
                              item-text="name" class="input-sm" dense outlined rounded hide-details placeholder="Edad"
                              :rules="oldRules" @change="mayorEdad()" />

                            <v-select v-else v-model="benef.edad" :items="hijoList" item-text="name" class="input-sm"
                              dense outlined rounded hide-details placeholder="Edad" @change="mayorEdad()" />
                          </div>
                        </div>
                      </div>

                      <div class="btn-center">
                        <v-btn class="btn-add" elevation="0" @click="addBeneficiary()">
                          <span class="plus">+</span> AGREGAR OTRO FAMILIAR
                        </v-btn>
                      </div>

                    </div>

                  </v-col>

                </v-card-text>

                <v-card-actions class="actions-vertical">

                  <v-btn style="color: white; margin: auto; height: 42px; padding: 15px 46px;
                 border-radius: 100px; background: #4F74E3;" elevation="0" @click="dialog = false">
                    ¡Todo listo!
                  </v-btn>

                  <v-btn text style="margin-top: 20px; color:#4F74E3;" @click="dialog = false">
                    X Prefiero plan individual
                  </v-btn>

                </v-card-actions>


              </v-card>


            </v-navigation-drawer>

            <br>

            <v-row v-if="planDataAux.plan.cantBenf.includes('familiar')"
              style="display: flex; justify-content: center;">
              <p style="margin-right: 2%;">Número de cargas agregadas: {{ benefData.length }} </p>
              <p style="color: #2A3881; font-weight: 600; cursor: pointer;" @click="dialog = true">Editar familiares</p>
            </v-row>

            <br>
            <div class="plan-recomen">

              <v-col class="text-center">

                <label class="planFamiliarConveniente">Plan Seguro Oncológico</label>

              </v-col>

            </div>
            <div class="plan-valid">

              <v-col class="text-center">

                <label class="planFamiliarConvenienteSub">Válido para Fonasa e Isapre</label>

              </v-col>

            </div>
            <div class="plan">

              <v-col class="text-center" style="max-width: 90% !important;">

                <p class="planFamiliarName">Precio mensual</p>

                <div style="display: flex; justify-content: center; height: 33px;">
                  <p class="planFamiliarPrecio">{{ formatPrice(planDataAux.plan.values[0].priceCLP) }} *</p>
                  <div>
                    <p></p>
                    <p class="planFamiliarSubPrecio"> UF {{ (planDataAux.plan.values[0].price).toFixed(2) }}</p>
                  </div>

                </div>




                <label class="planFamiliarSubDetalle">* Valor de la UF al día de hoy, {{ currentDate }} .</label>

                <div class="planShield">
                  <img :src=iconShield alt="Protecciones" class="imgShield">
                  <p class="planShieldDetalle">El Plan otorga <b style="color: #4F74E3;">atención y cobertura</b>
                    completa
                    de los gastos que implica el tratamiento, control y seguimiento del cáncer.</p>
                </div>

                <div class="planSubShield">
                  <img :src=iconSand alt="Protecciones" class="imgSand">
                  <p class="planSubShieldDetalle">Este seguro tiene un tiempo de espera de activación de 30 días
                    contínuos.</p>
                </div>

                <p></p>

                <v-btn v-if="loadingNext == false" class="button-desing"
                  style="background-color: #4F74E3 !important; margin-bottom: 5%;" @click="validate()">
                  <label style="color: #FFFFFF; cursor: pointer;">Continuar</label>
                </v-btn>

                <div v-if="loadingNext == true" class="text-center" style="margin-top:5%">
                  <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
                </div>

              </v-col>

            </div>


          </div>

        </v-form>

        <div>
          <div class="plan-skin" style="border-radius: 0px 0px 0px 0px !important;">

            <h3 class="text-center labelTituloo"> Esto incluye tu plan
            </h3>

            <v-col class="text-center">
              <br>

              <p class="planIndividualBeneficios">Cubre tratamiento para todos los tipos de cáncer, incluso cáncer in
                situ y el tratamiento del cáncer a la piel.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">La atención oncológica es solo en la ciudad de Santiago de Chile.
                Traslados y estadías no estarán cubiertos por el seguro.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Todo el tratamiento integral del paciente lo realiza Clínica IRAM,
                derivando a los profesionales y/o centros hospitalarios en convenio en la ciudad de Santiago.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Cubre la realización de exámenes y procedimientos necesarios para
                identificar el tipo y estado de extensión del cáncer.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Ejecución de tratamiento comprobado y multidisciplinario de la
                enfermedad (Cirugía, Quimioterapia y Radioterapia).
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Hospitalización como un todo. Incluye los días cama, derechos de
                pabellón, UTI intermedio, procedimientos diagnósticos intrahospitalarios.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Incluye todos los honorarios médicos: quirúrgicos, de radioterapeutas,
                de quimioterapeutas y honorarios del equipo paramédico quirúrgico.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Cobertura vitalicia mientras se mantenga el pago y la póliza vigente.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Ante diagnóstico de cáncer positivo, recibirás una indemnización de UF
                50 para libre disposición.
              </p>
              <div class="plan-info">
                <button>
                  <b>
                    <u class="planIndividualVerDetalle" elevation="0" @click="InfoIndividual()">
                      Ver más detalles
                    </u>
                  </b>
                </button>
              </div>
              <p></p>
              <p class="planSubTopes">Topes posteriores a tu cobertura de Fonasa o Isapre:
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Drogas antineoplásicas: tope UF 100 por cada tratamiento de
                quimioterapia.
              </p>
              <p></p>
              <p class="planIndividualBeneficios">Farmacia intrahospitalaria: medicamentos, insumos, materiales clínicos
                y banco de sangre: UF 4 tope por hospitalización.
              </p>

              <p style="margin-top: 13%;"></p>

            </v-col>

            <br>

          </div>

        </div>
      </v-row>

    </div>

  </div>
</template>

<script>
import LibreEleccion from "../assets/images/libreeleccion.png";
import iconShield from "../assets/images/shield-check.svg";
import iconSand from "../assets/images/time-sand.svg";
import ShieldService from "../services/shield.service";
import CryptoJS from 'crypto-js';
import swal from 'sweetalert';

import agelist from "@/services/age-list.service.js";
import hijoList from "@/services/hijo-list.service.js";
import partnerList from "@/services/partner-age-list.service.js";


import planIndividualColor from "@/assets/images/planIndividualColor.png";
import planFamiliarColor from "@/assets/images/planFamiliarColor.png";
import planIndividual from "@/assets/images/planIndividual.png";
import planFamiliar from "@/assets/images/planFamiliar.png";
import popUpImage from "@/assets/images/popUpImage.svg";


import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Plan",
  props: ["planData", "planDataAux", "index", "userData", "benefData", "loadingPlans", "servicesData", "plansOutDesc"],
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    valid: false,
    popUpImage,
    loadingNext: false,
    imageIndividual: planIndividualColor,
    imageFamiliar: planFamiliar,
    formatterUF: new Intl.NumberFormat("es-CL"),
    LibreEleccion,
    iconSand,
    currentDate: "",
    iconShield,
    info: [['Isapre Individual', 'Isapre Familiar', 'Fonasa Individual', 'Fonasa Familiar'], ['100%', '100%', '100%', '100%'], ['50', '50', '50', '50'], ['30.000', '30.000', '30.000', '30.000'], ['5.000', '5.000', '5.000', '5.000'], ['50', '50', '50', '50'], ['10', '10', '10', '10'], ['0', '30.000', '0', '30.000'], ['0', '50', '0', '50']],
    indexInfo: '0',
    dialogIndividual: false,
    dialogFamiliar: false,
    dialog: false,
    dialogInternal: false,
    document: null,
    agelist: [],
    hijoList: [],
    partnerList: [],
    personType: [
      "Hijo(a)",
      "Pareja",
      "Cónyuge",
    ],
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    // benefData: [
    //   {
    //     tab: '',
    //     validRut: false,
    //     tipo: null,
    //     edad: null,
    //     name: '',
    //     surname: '',
    //     rut: '',
    //     days: ['Selecciona el mes'],
    //     months: null,
    //     years: null,
    //     date: null,
    //     newRut: '',
    //     panel: 0,
    //     year: null,
    //     month: null,
    //     day: null,
    //   }
    // ],
    parentescoRules: [
      (v) => !!v || "El parentesco es requerido",
    ],
    nameRules: [
      // (v) => !!v || "El nombre es requerido",
      (v) => !!v.trim() || "El nombre es requerido",
      // (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    surnameRules: [
      // (v) => !!v || "El apellido es requerido",
      (v) => !!v.trim() || "El apellido es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    oldRules: [
      (v) => !!v || "La edad es requerida",
    ],
  }),
  async mounted() {

    if ("imageIndividual" in sessionStorage) {
      this.imageIndividual = sessionStorage.getItem('imageIndividual');
      this.imageFamiliar = sessionStorage.getItem('imageFamiliar');
    }

    let index = sessionStorage.getItem('index');
    if (index == 2) {
      this.planDataAux.plan = this.planData[1];
    }

    if (this.userData.old.id > 52) {
      this.planDataAux.plan = this.planData[0];
    }

    this.getAgeList();
    this.getHijoList();
    this.getPartnerList();
    this.mayorEdad();

    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const today = new Date();
    this.currentDate = today.toLocaleDateString("es-CL");
  },
  methods: {
    ufFormat(price) {
      return this.formatterUF.format(price);
    },
    InfoFamiliar() {
      if (this.planData.name == 'Plan Familiar ISAPRE') {
        this.indexInfo = 1
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData.name == 'Plan Familiar FONASA') {
        this.indexInfo = 3
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogFamiliar = true
    },
    InfoIndividual() {
      if (this.planData.name == 'Plan Individual ISAPRE') {
        this.indexInfo = 0
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData.name == 'Plan Individual FONASA') {
        this.indexInfo = 2
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogIndividual = true
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    change(index, tipo) {
      const tiposRestringidos = ['Pareja', 'Cónyuge'];

      if (tiposRestringidos.includes(tipo)) {
        const existe = this.benefData.some(
          (b, i) => tiposRestringidos.includes(b.tipo) && i !== index
        );

        if (existe) {
          swal({
            title: "¡Atención!",
            text: "¡No puedes agregar más de un conviviente o pareja!",
            icon: "info",
            button: "De acuerdo",
          });
          this.$nextTick(() => {
            this.benefData[index].tipo = '';
          });
          return;
        }
      }

      this.benefData[index].tipo = tipo;
    },
    ufchange(uf) {
      let nn = uf.toString();
      let new_uf = nn.replace('.', ',')
      return new_uf;
    },
    async selectPlan(index) {
      if (index == 1) {
        sessionStorage.setItem('index', index);
        this.imageIndividual = planIndividualColor;
        this.imageFamiliar = planFamiliar;
        sessionStorage.setItem('imageIndividual', planIndividualColor);
        sessionStorage.setItem('imageFamiliar', planFamiliar);
        this.planDataAux.plan = this.planData[0];
      } else if (index == 2) {
        sessionStorage.setItem('index', index);
        this.imageIndividual = planIndividual;
        this.imageFamiliar = planFamiliarColor;
        sessionStorage.setItem('imageIndividual', planIndividual);
        sessionStorage.setItem('imageFamiliar', planFamiliarColor);
        this.planDataAux.plan = this.planData[1];
      }
    },
    addBeneficiary() {
      if (this.benefData.length <= 4) {
        let beneficiarioAux = {
          tab: '',
          validRut: false,
          tipo: null,
          edad: null,
          name: '',
          surname: '',
          rut: '',
          days: ['Selecciona el mes'],
          months: null,
          years: null,
          date: null,
          newRut: '',
          panel: 0,
          year: null,
          month: null,
          day: null,
        }
        this.benefData.push(beneficiarioAux);
      } else {
        swal({
          title: "¡Atención!",
          text: "¡No puedes agregar mas familiares!",
          icon: "info",
          button: "De acuerdo",
        });
      }
    },
    async deletedBeneficiary(index) {
      if (this.benefData.length >= 2) {
        this.benefData.splice(index, 1);
        this.mayorEdad();
      }

    },
    async mayorEdad() {
      if (this.benefData.length != 0) {

        this.userData.typePlan = 'familiar';

        const validBeneficiaries = this.benefData.filter(benef => benef.edad !== null);

        if (validBeneficiaries.length === 0) {
          this.userData.oldAux = this.userData.old.name;
        } else {
          const oldestBeneficiary = validBeneficiaries.reduce((oldest, current) => {
            return (current.edad.name > oldest.edad.name) ? current : oldest;
          }, validBeneficiaries[0]);

          if (this.benefData.length == 1) {
            this.userData.oldAux = oldestBeneficiary.edad.name;
          } else {
            this.userData.oldAux = this.userData.old.name < oldestBeneficiary.edad.name ? oldestBeneficiary.edad.name : this.userData.old.name;
          }

        }

      } else {
        this.userData.oldAux = this.userData.old.name;
        this.userData.typePlan = 'Individual';
      }

    },
    async getAgeList() {
      this.loadingAgeList = true;
      this.agelist = await agelist.getAgeList();
      this.loadingAgeList = false;
    },
    async getHijoList() {
      this.loadingHijoList = true;
      this.hijoList = await hijoList.getHijoList();
      this.loadingHijoList = false;
    },
    async getPartnerList() {
      this.loadingPartnerAgeList = true;
      this.partnerList = await partnerList.getAgeList();
      this.loadingPartnerAgeList = false;
    },
    capitalizeName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    async validate() {

      if (this.planDataAux.plan.cantBenf.includes('individual')) {
        this.loadingNext = true
      }

      if (this.planDataAux.plan.cantBenf.includes('familiar')) {
        if (this.$refs.form.validate()) {
          this.loadingNext = true
          this.logicMethod();

        } else {
          swal({
            title: "¡Atención!",
            text: "¡Complete los datos de los beneficiarios!",
            icon: "info",
            button: "Completar",
          });
        }
      } else {
        this.logicMethod();
      }

    },
    async logicMethod() {

      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      const planDataLocal = JSON.stringify(this.planDataAux);
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      sessionStorage.setItem('planData', encryptedPlanDataLocal);

      const benefDataLocal = JSON.stringify(this.benefData);
      const encryptedbenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();
      sessionStorage.setItem('benefData', encryptedbenefDataLocal);

      this.userData.typePlan = this.planDataAux.plan.cantBenf.includes('familiar') ? 'Familiar' : 'Individual';

      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      sessionStorage.setItem('userData', encryptedUserDataLocal);

      try {

        let carro = await ShieldService.newCreateStep(this.userData, this.planDataAux.plan.cantBenf.includes('familiar') ? this.benefData : {}, this.planDataAux, this.servicesData, 'Planes', tokenStep);
        this.servicesData.type = 'update';
        this.servicesData.stepId = carro.data.data._id;

      } catch (error) {
        console.log("Cart Fail");
      }

      if (this.userData.email && this.activeCampaingUse == 'TRUE') {
        const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

        this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;

        await ShieldService.updateContactActiveCampain(null, this.planDataAux, this.servicesData, 1);

      }

      const servicesDataLocal = JSON.stringify(this.servicesData);
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      // if (this.planDataAux.plan.cantBenf.includes('familiar')) {
      //   this.$router.push({ path: '/og/beneficiarios' })
      // } else {
      //   this.$router.push({ path: '/og/dps' })
      // }
      this.$router.push({ path: '/og/dps' })
    },
    parseNumber(n) {
      return new Intl.NumberFormat().format(n);
    },
  },
};
</script>

<style lang="scss" scoped>
.benef-card {
  max-width: 340px;
  margin: 0 auto 20px auto;
}

.benef-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0 6px;
}

.benef-title {
  color: #1f2a8a;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .5px;
}

.benef-remove {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  background: transparent;
  border: 0;
  color: #C0392B;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}

.benef-x {
  font-size: 16px;
  line-height: 1;
}

.field-label {
  display: block;
  font-size: 12px;
  color: #4b4b4b;
  margin: 10px 0 6px;
  font-weight: 600;
}

.input-sm.v-text-field,
.input-sm.v-select {
  margin-bottom: 10px;
}

.input-sm .v-input__slot {
  min-height: 40px !important;
  border-radius: 10px !important;
}

.field-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.btn-center {
  display: flex;
  justify-content: center;
}

.btn-add {
  max-width: 340px;
  border: 2px solid #19287a !important;
  background: #fff !important;
  color: #19287a !important;
  border-radius: 999px !important;
  font-weight: 700;
  height: 42px !important;
  margin: 8px 0 24px 0;
}

.btn-add .plus {
  display: inline-block;
  margin-right: 8px;
  font-size: 18px;
  line-height: 1;
}

.family-drawer .v-card__title {
  padding-bottom: 8px !important;
}

.family-drawer .v-card__text {
  padding-top: 8px !important;
}

.actions-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.hrline {
  width: 80%;
  border: 1px solid #E1E1E1;
  margin: auto;
  margin-top: 2%;
}

.planFamiliarRecomendado {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 25px;
  gap: 8px;
  width: 171px;
  height: 22px;
  background: #A74CF2;
  border-radius: 5px;
  margin: auto;
  margin-top: 5%;
}

.planFamiliarConveniente {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #FFF;
  ;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarConvenienteSub {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #FFF;
  ;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarName {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  color: #2D387C;
  margin: auto;
  margin-top: 0%;
}

.planFamiliarPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #4F74E3;
}

.planFamiliarSubPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: #2D387C;
  margin-bottom: 0px !important;
}

.planFamiliarSubDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2D387C;
}

.planShield {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 46px;
  background: #ECF0FC;
  border-radius: 4px;
  padding-right: 2%;
  margin-top: 2%;
}

.imgShield {
  width: 50px;
  height: 50px;
  margin-left: 7px;
}

.imgSand {
  width: 15px;
  height: 15px;
}

.planShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  text-align: center;
  color: #2D387C;
  margin: auto;
  width: 85ca7 !important;
}

.planSubShield {
  background: #F3F3F3;
  border-radius: 4px;
  width: 100%;
  height: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 8px;
}

.planSubShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #2D387C;
  margin: auto;
  width: 400px;
}

.planFamiliarLinea {
  width: 214px;
  height: 0px;
  border: 0.946207px solid #FFFFFF;
  margin: auto;
}

.planFamiliarProtege {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.02em;
  color: #2D3748;
  width: 250px;
  justify-content: center;
  margin: auto;
}

.planFamiliarCaracteristicas {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarBeneficios {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D3748;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 250px;
  text-align: justify;
  margin: 0 auto;
  margin-bottom: 10px;
  padding-left: 5px;
}

.planFamiliarBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  width: 16px !important;
  height: 16px !important;
  margin-left: -23px;
}


.planFamiliarVerDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #FFFFFF;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.elegirPlan {
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  width: 238px;
  height: 37px;
  background: #4F74E3;
  border: 2px solid #4F74E3;
  border-radius: 8px;
  font-weight: 800;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0px;
  text-transform: uppercase;
}

.planIndividualName {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  color: #343497;
  margin: auto;
  margin-top: 9%;
}

.planIndividualPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #343497;
  margin: auto;
}

.planIndividualSubPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: rgba(53, 53, 53, 0.65);
  margin-bottom: 0px !important;
}

.planIndividualSubDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: rgba(58, 58, 58, 0.85);
}

.planIndividualLinea {
  width: 214px;
  height: 0px;
  border: 0.946207px solid #2D387C;
  margin: auto;
  margin-top: -7%;
}

.planIndividualProtege {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.02em;
  color: #2D3748;
  width: 200px;
  justify-content: center;
  margin: auto;

}

.planIndividualCaracteristicas {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planSubTopes {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  text-align: left;
  color: #4F74E3;
  display: flex;
  justify-content: center;
}

.planSubTopes2 {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  text-align: left;
  color: #4F74E3;
}

.planIndividualBeneficios {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: #282828;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 370px;
  text-align: justify;
  margin: 0 auto;
  margin-bottom: 10px;
  padding-left: 7px;
}

.planIndividualBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  width: 16px !important;
  height: 16px !important;
  margin-left: -36px;
}

.planIndividualVerDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  color: #2D387C;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.texto {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.02em;
  color: #333333;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.textoAzul {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D387C;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.encabezado {
  color: #2D387C;
  font-size: 18px;
  font-weight: 800;
}

.plan-info {
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4%;
}

.plan {
  background: #FFF;
  border: 1px solid #ECECEC;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  width: 500px;
}

.plan-recomen {
  background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  border-radius: 10px 10px 0px 0px;
  width: 500px;
  height: 30px;
}

.plan-valid {
  background: #2D387C;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  width: 500px;
  height: 10px;
}

.buttonAceptar {
  background: #4F74E3;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;
  font-size: 12px;
  width: 174px !important;
  height: 40px !important;
  color: white !important;
  margin: auto;
}

.plan-skin {
  background: #FFFFFF;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0px 0px 10px 10px;
  width: 500px;
  border-color: #ECECEC;
  border: 1px solid #ECECEC;
}

.superpuesto {
  content: 'Nuevo';
  margin-top: -4% !important;
  width: 55px !important;
  height: 48px;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
  background: #4F74E3;
  border-radius: 0px 10px 0px 20px;
  margin-left: 269px;
  margin-bottom: -25px;
}

.p-desc {
  // font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 14px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin: auto;
}

.superpuestoFam {
  content: 'Nuevo';
  margin-top: -4.4% !important;
  width: 55px !important;
  height: 48px;
  justify-content: center;
  align-items: center;
  color: #2D387C;
  font-size: 14px;
  font-weight: bold;
  background: #ECECEC;
  border-radius: 0px 00px 0px 10px;
  margin-left: 243px;
  margin-bottom: -15px;
}

.p-descFam {
  // font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 14px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #2D387C;
  margin: auto;
}

.v-expansion-panel-header {
  background: #ECF0FC !important;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: #2D387C;
  border-radius: 10px !important;
  padding: 3px 20px;
  // height: 75% !important;
}

.v-expansion-panel::before {
  border-radius: 10px;
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none !important;
}

.v-expansion-panel {
  flex: 9 0 99%;
  max-width: 100%;
  position: initial !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.v-expansion-panels {
  margin: auto;
  width: 93% !important;
}

.text-expan {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 28px;
  color: #4D4D4D !important;
}

.labelEtiqueta {
  display: flex;
  align-items: flex-start;
  font-weight: 700;
  color: #505050;
  font-size: 13px;
}
</style>

<style lang="scss">
.family-drawer {
  overflow: hidden !important;
  height: 100vh !important;
}

.family-drawer .v-navigation-drawer__content {
  overflow: hidden !important;
}

.family-drawer .v-card__text {
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: calc(100vh - 280px);
}

.left-scrim {
  position: fixed;
  inset: 0 420px 0 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 2049;
}

@media (max-width: 960px) {
  .left-scrim {
    inset: 0;
  }

  .family-drawer {
    width: 100vw !important;
  }
}
</style>